import * as React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';

import {useAcceptanceHistoryQuery} from '../../services/documentsApi';

import {parseToEasternTime} from '../../utils/dates';

// api response example
// [{"name":"documentForBees","version":1,"acceptedOn":"2022-12-27T15:13:33.5","currentVersion":1}]

export default function DocumentsHistory({user}) {
  const {data: documentsAccepted, isLoading , isError} = useAcceptanceHistoryQuery(user.id);

  const columns = [
    {
        field: 'id',
        hide: true,
        headerName: 'ID',
        flex: 1
    },
    {
        field: 'documentTypeName',
        headerName: 'Name',
        flex: 1
    },
    {
        field: 'firstViewedOn',
        headerName: 'First Viewed On',
        valueGetter: (params) => (parseToEasternTime(params.row.firstViewedOn)),
        flex: 1
  },
    {
        field: 'documentVersion',
        headerName: 'Document Version',
        flex: 1
    },
    {
        field: 'acceptedOn',
        headerName: 'Accepted',
        valueGetter: (params) => (parseToEasternTime(params.row.acceptedOn)),
        flex: 1
    },
    {
      field: 'documentTypeCurrentVersion',
      headerName: 'Current Version',
      flex: 1
  },
  ] 

  return (
    <Box sx={{ height: 425, width: '100%', backgroundColor:"white", borderRadius:"1em", padding:"1em"}}>
      <DataGridPro
        rows={documentsAccepted || []}
        columns={columns}
        rowHeight={38}
        loading={isLoading}
        //checkboxSelection
        disableSelectionOnClick
        //experimentalFeatures={{ newEditingApi: true }}
      />
      
      </Box>
  );
}